// @mui material components
import {
  Snackbar,
  Alert,
  Card,
  CircularProgress,
  Backdrop,
  Icon,
  Tooltip,
  Button,
  Dialog,
  DialogContent,
  DialogActions,
  Divider,
  DialogTitle,
} from "@mui/material";

// Material Dashboard 2 React components
import MDBox from "theme/components/MDBox";
import MDTypography from "theme/components/MDTypography";
import MDButton from "theme/components/MDButton";
// import MDInput from "theme/components/MDInput";

// Material Dashboard 2 React example components
import DashboardLayout from "app/LayoutContainers/DashboardLayout";
import DashboardNavbar from "app/Navbars/DashboardNavbar";
import Footer from "theme/Footer";

import { useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import axios from "axios.js";
// import AppConfig from "appConfig";
import DataTable from "theme/Tables/DataTable";
import usePageTitle from "app/pageTitle";

function AttendanceEntriesPage() {
  const pageTitle = "Attendees";
  usePageTitle(pageTitle);
  const { ref } = useParams();
  // const navigate = useNavigate();

  const [showLoading, setShowLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [errorMsg, setErrMsg] = useState("");
  const [severity, setSeverity] = useState("");
  const handleClose = () => {
    setOpen(false);
    setErrMsg("");
  };

  const [refreshPage, setRefreshPage] = useState(false);
  const [pageLoaded, setPageLoaded] = useState(false);
  const [attendance, setAttendance] = useState({});
  const [attendees, setAttendees] = useState([]);

  const [selectedRecord, setSelectedRecord] = useState(null);
  const [openSelectedRecordDialog, setOpenSelectedRecordDialog] = useState(false);

  const agentAttendancesTableColumns = [
    // { Header: "Photo", accessor: "photo", align: "left" },
    { Header: "#", accessor: "record", align: "left" },
    { Header: "Agent", accessor: "agent", align: "left" },
    { Header: "Group", accessor: "group", align: "left" },
    { Header: "Location", accessor: "location", align: "left" },
    { Header: "Type", accessor: "entry_type", align: "left" },
    { Header: "On Time", accessor: "late", align: "left" },
    { Header: "Time", accessor: "created", align: "left" },
  ];

  const buildAttendancesRows = (data) => {
    const rows = [];
    data.map((entry) => {
      rows.push({
        // photo: (
        //   <MDBox>
        //     {entry.photo ? (
        //       <img src={entry.photo} alt="" width={36} />
        //     ) : (
        //       <MDTypography variant="h6" fontWeight="light" fontSize={14}>
        //         ---
        //       </MDTypography>
        //     )}
        //   </MDBox>
        // ),
        agent: entry.agent,
        created: entry.created,
        entry_type: entry.entry_type,
        group: entry.group,
        location: entry.location,
        late: entry.is_on_time ? "ON-TIME" : "LATE",
        record: (
          <MDBox>
            <Tooltip title="View Log">
              <MDButton
                size="small"
                variant="contained"
                color="info"
                iconOnly
                onClick={() => {
                  setSelectedRecord(entry);
                  setOpenSelectedRecordDialog(true);
                }}
              >
                <Icon sx={{ cursor: "pointer" }} fontSize="small" color="dark">
                  visibility
                </Icon>
              </MDButton>
            </Tooltip>
            &nbsp;&nbsp;
            <Tooltip title="View On Map">
              <MDButton
                size="small"
                variant="contained"
                color="error"
                iconOnly
                onClick={() => {
                  const maplink = `https://maps.google.com?q=${entry.latitude},${entry.longitude}`;
                  window.open(maplink, "_blank");
                }}
              >
                <Icon sx={{ cursor: "pointer" }} fontSize="small" color="dark">
                  pin_drop
                </Icon>
              </MDButton>
            </Tooltip>
          </MDBox>
        ),
      });
      return null;
    });

    return rows;
  };

  useEffect(() => {
    const fetchData = async () => {
      setShowLoading(true);
      await axios
        .get(`/portal/attendances/${ref}/attendees.json`)
        .then((result) => {
          // console.log(result);
          setShowLoading(false);
          if (result.data.status === "success") {
            setAttendance(result.data.data.attendance);
            const attendances = buildAttendancesRows(result.data.data.attendees);
            setAttendees(attendances);
            setPageLoaded(true);
          } else {
            setSeverity("error");
            setErrMsg(result.data.data.message);
            setOpen(true);
          }
        })
        .catch(() => {
          setShowLoading(false);
          setSeverity("error");
          setErrMsg(
            `Unable to complete request. ${
              navigator.onLine ? "" : "Make sure you have an active internet connection"
            }`
          );
          setOpen(true);
        });
    };

    fetchData();
  }, [refreshPage]);

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={showLoading}
        onClick={handleClose}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <Snackbar
        open={open}
        autoHideDuration={6000}
        onClose={handleClose}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert onClose={handleClose} severity={severity} sx={{ width: "100%" }}>
          {errorMsg}
        </Alert>
      </Snackbar>
      {selectedRecord && (
        <Dialog open={openSelectedRecordDialog} fullWidth maxWidth="xs">
          <DialogTitle>
            <MDBox mt={1} align="center">
              <MDTypography variant="h6" fontWeight="bold" fontSize={14}>
                {selectedRecord.entry_type}
              </MDTypography>
              <MDTypography variant="h6" fontWeight="light">
                {selectedRecord.created}
              </MDTypography>
              <MDTypography variant="h6" color={selectedRecord.is_on_time ? "success" : "error"}>
                {selectedRecord.is_on_time ? "ON-TIME" : "LATE"}
              </MDTypography>
            </MDBox>
          </DialogTitle>
          <DialogContent>
            <MDBox mb={5}>
              {selectedRecord.photo && (
                <MDBox>
                  <MDBox align="center">
                    <img src={selectedRecord.photo} alt="" height={240} />
                  </MDBox>
                  <MDBox mt={3}>
                    <Divider />
                  </MDBox>
                </MDBox>
              )}
              <MDBox mt={3} p={1}>
                <MDBox display="flex" justifyContent="space-between">
                  <MDBox>
                    <MDTypography variant="h6" fontWeight="regular">
                      Agent
                    </MDTypography>
                  </MDBox>
                  <MDBox align="right">
                    <MDTypography variant="h6" fontWeight="light">
                      {selectedRecord.agent}
                    </MDTypography>
                  </MDBox>
                </MDBox>
                <MDBox mt={2} display="flex" justifyContent="space-between">
                  <MDBox>
                    <MDTypography variant="h6" fontWeight="regular">
                      Group
                    </MDTypography>
                  </MDBox>
                  <MDBox align="right">
                    <MDTypography variant="h6" fontWeight="light">
                      {selectedRecord.group}
                    </MDTypography>
                  </MDBox>
                </MDBox>
                <MDBox mt={2} display="flex" justifyContent="space-between">
                  <MDBox>
                    <MDTypography variant="h6" fontWeight="regular">
                      Location
                    </MDTypography>
                  </MDBox>
                  <MDBox align="right">
                    <MDTypography variant="h6" fontWeight="light">
                      {selectedRecord.location}
                    </MDTypography>
                  </MDBox>
                </MDBox>
                {selectedRecord.custom_fields.map((field) => (
                  <MDBox mt={2} display="flex" justifyContent="space-between">
                    <MDBox>
                      <MDTypography variant="h6" fontWeight="regular">
                        {field.field}
                      </MDTypography>
                    </MDBox>
                    <MDBox align="right">
                      <MDTypography variant="h6" fontWeight="light">
                        {field.value}
                      </MDTypography>
                    </MDBox>
                  </MDBox>
                ))}
                <MDBox mt={2} display="flex" justifyContent="space-between">
                  <MDBox>
                    <MDTypography variant="h6" fontWeight="regular">
                      GPS
                    </MDTypography>
                  </MDBox>
                  <MDBox align="right">
                    <MDTypography variant="h6" fontWeight="light">
                      {selectedRecord.latitude}, {selectedRecord.longitude}
                    </MDTypography>
                  </MDBox>
                </MDBox>
                {/* <MDBox mt={2} display="flex" justifyContent="space-between">
                  <MDBox>
                    <MDTypography variant="h6" fontWeight="regular">
                      Time
                    </MDTypography>
                  </MDBox>
                  <MDBox align="right">
                    <MDTypography variant="h6" fontWeight="light">
                      {selectedRecord.created}
                    </MDTypography>
                  </MDBox>
                </MDBox> */}
              </MDBox>
            </MDBox>
          </DialogContent>
          <DialogActions>
            <MDButton
              variant="outlined"
              color="error"
              circular
              iconOnly
              onClick={() => {
                const maplink = `https://maps.google.com?q=${selectedRecord.latitude},${selectedRecord.longitude}`;
                window.open(maplink, "_blank");
              }}
            >
              <Icon sx={{ cursor: "pointer" }} fontSize="small" color="dark">
                pin_drop
              </Icon>
            </MDButton>
            &nbsp;
            <MDButton
              variant="outlined"
              color="dark"
              circular
              iconOnly
              onClick={() => setOpenSelectedRecordDialog(false)}
            >
              <Icon>close</Icon>
            </MDButton>
          </DialogActions>
        </Dialog>
      )}
      {pageLoaded && (
        <MDBox mt={2} mb={3}>
          <MDBox mb={1} display="flex" justifyContent="space-between">
            <MDBox ml={-2}>
              <Button
                color="dark"
                startIcon={<Icon>chevron_left</Icon>}
                onClick={() => {
                  window.history.back();
                }}
              >
                Back
              </Button>
            </MDBox>
            <MDBox>
              <Button
                color="dark"
                startIcon={<Icon>sync</Icon>}
                onClick={() => {
                  setRefreshPage(!refreshPage);
                }}
              >
                Refresh
              </Button>
            </MDBox>
          </MDBox>
          <MDBox>
            <Card>
              <MDBox p={2}>
                <MDBox mb={1}>
                  <MDTypography variant="h6" fontSize={14} fontWeight="light">
                    Attendance Tracker
                  </MDTypography>
                  <MDTypography variant="h6">{attendance.title}</MDTypography>
                </MDBox>
              </MDBox>
            </Card>
          </MDBox>
          <MDBox mt={5}>
            <Card>
              <MDBox>
                <MDBox p={2}>
                  <MDTypography variant="h6">Attendance Logs</MDTypography>
                </MDBox>
                <MDBox>
                  {attendees.length > 0 ? (
                    <MDBox mb={3}>
                      <DataTable
                        table={{ columns: agentAttendancesTableColumns, rows: attendees }}
                        isSorted
                        entriesPerPage={false}
                        showTotalEntries
                        buttons
                        noEndBorder
                      />
                    </MDBox>
                  ) : (
                    <MDBox p={2}>
                      <MDTypography variant="caption" fontSize={14}>
                        No agents have logged attendance yet.
                      </MDTypography>
                    </MDBox>
                  )}
                </MDBox>
              </MDBox>
            </Card>
          </MDBox>
        </MDBox>
      )}
      <Footer />
    </DashboardLayout>
  );
}

export default AttendanceEntriesPage;
